import { Text, TextLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useTravelDetailsPresenter } from './useTravelDetailsPresenter'
import { TravelDetailContent } from '../../views/TravelDetailContent'

export interface ITravelDetailsPresenterProps {
  uuid: string
}

export const TravelDetailsPresenter = ({
  uuid,
}: ITravelDetailsPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { travel },
    states: { isLoading, error },
  } = useTravelDetailsPresenter({ uuid })

  if (isLoading) {
    return (
      <div>
        <TextLoader />
        <TextLoader />
        <TextLoader />
      </div>
    )
  }

  if (error || !travel) {
    return <Text>{intl.formatMessage(messages.errorMessage)}</Text>
  }

  return <TravelDetailContent travel={travel} />
}

TravelDetailsPresenter.displayName = 'TravelDetailsPresenter'
